import { App, Button, Card, Col, Input, message, Modal, Pagination, Popconfirm, Row, Select, Space, Spin, Table, Tag, Upload, } from "antd";
import { Option } from "antd/es/mentions";
import { EyeFilled, LoadingOutlined, UploadOutlined, LeftOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { BULK_ADD_USER, LIST_USER, USER_STATUS, BULD_USER_IMPORT_TEMPLATE, USER_CAMP } from "../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import { formatToIST } from "../../../helper/CommonHelper";


function UserCamp() {

  const [page_size, set_page_size] = useState(10);
  const navigate = useNavigate();
  const location = useLocation();


  //USE STATE FOR PAGINATION AND LOADER
  const { user_id } = useParams();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState(false);
  const [current_page, set_current_page] = useState("");
  const [total_pages, set_total_pages] = useState("");
  const [total_users, set_total_users] = useState("");
  const [users_data, set_users_data] = useState("");


  const handleBack = () => {
    if (location.state?.from) {
      navigate(location.state.from);
    } else {
      navigate(-1); // fallback
    }
  };


  const LIST_API = async () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("user_id", atob(user_id));

    const API_CALL = await USER_CAMP(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_users_data(API_CALL?.data?.user)
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  useEffect(() => {
    LIST_API();
  }, []);



  const columns = [
    {
      title: "Campaign Name",
      dataIndex: "campaign_name",
      render: (text, record) => (
        <span>
          {record.campaign_name}
        </span>
      ),
    },
    {
      title: "Group Name",
      dataIndex: "group_name",
      render: (text, record) => <span>{record.group_details.group_name}</span>,
    },
    {
      title: "Email Template",
      dataIndex: "email_template",
      render: (text, record) => <span>{record.email_template.template_name || "No Data"}</span>,
    },
    {
      title: "Landing Page",
      dataIndex: "landing_page",
      render: (text, record) => <span>{record.landing_page.name || "No Data"}</span>,
    },
    {
      title: "Tracking Data",
      dataIndex: "tracking_data",
      render: (text, record) => <div style={{ minWidth: "120px", display: "block" }}> <span >  Tracking Status:  {record?.tracking_data?.tracking_status === 0 && (
        <span style={{ color: "#8c3add" }}>Email Sent</span>
      )}
        {record?.tracking_data?.tracking_status === 1 && (
          <span style={{ color: "#1fa7a1" }}>Email Opened</span>
        )}
        {record?.tracking_data?.tracking_status === 2 && (
          <span style={{ color: "#eab451" }}>Clicked Link</span>
        )}
        {record?.tracking_data?.tracking_status === 3 && (
          <span style={{ color: "#b37feb" }}>Submitted Data</span>
        )}
        {record?.tracking_data?.tracking_status === 200 && (
          <span style={{ color: "#f97d7d" }}>Spam Email</span>
        )}
        {record?.tracking_data?.tracking_status === 522 && (
          <span style={{ color: "#f97d7d" }}>Spam + Copyright</span>
        )}
        {record?.tracking_data?.tracking_status === 523 && (
          <span style={{ color: "#ad3a05ff" }}>Bot Detection</span>
        )}</span><br></br>
        <span> Clicked Browser: {record?.tracking_data?.clicked_browser}</span><br></br>
        <span> Date: {formatToIST(record?.tracking_data?.created_at)}</span>
      </div>
    },

  ];


  return (
    <div className="lms-body">

      <Row align="middle">
        <Col span={12}>
          <h2>
            <span style={{ cursor: "pointer" }} onClick={handleBack}>
              <LeftOutlined /> User Camp</span>

          </h2>
        </Col>
      </Row>


      <Card>

        {loader ? (
          <>
            <CulsightPageLoader />
          </>
        ) : (
          <>
            {pagination_loader ? (
              <>
                <div style={{ textAlign: "center", padding: "60px" }}>
                  <Spin indicator={<LoadingOutlined spin />} size="large" />
                </div>
              </>
            ) : (
              <>
                <h3>Name: <i style={{ color: "#8c3add" }}>{users_data?.name}</i>, Email: <i style={{ color: "#8c3add" }}>{users_data?.email}</i></h3>
                <Table
                  columns={columns}
                  pagination={false}
                  dataSource={table_data}
                  style={{ marginTop: "15px" }}
                />
              </>
            )}
          </>
        )}
      </Card>
    </div>
  );
}

export default UserCamp;
